import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import CryptoJS from "crypto-js";
import { useApi } from "../../../hooks/useApi";
import useMy from "../../../hooks/useMy";
import ConfirmBtn from "../../Button/ConfirmBtn";
import LoginInput from "../../Input/LoginInput";
import LoginErrorMessage from "../../Login/LoginErrorMessage";
import DefaultModalLayout from "../../Modal/DefaultModalLayout";
import { LoginInputModalContainer } from "../Login/PwResettingModal";
import { useLocation, useNavigate } from "react-router-dom";
import { loginErrMsgString, userDataType } from "../../../pages/Login";
import { useSetRecoilState } from "recoil";
import Loader from "../../DefaultStyles/Loader";
import { toast } from "react-toastify";
import AlertModal from "../../Modal/AlertModal";

interface OldPwInputModalProps {
  closeEvent: () => void;
  confirmEvent: () => void;
  oldPw: string;
  setOldPw: Dispatch<SetStateAction<string>>;
}

export default function OldPwInputModal({
  closeEvent,
  confirmEvent,
  oldPw,
  setOldPw,
}: OldPwInputModalProps) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { email } = useMy();
  const [isWrong, setIsWrong] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [btnClick, setBtnClick] = useState(false);
  const [executeLogout, setExecuteLogout] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [alertModal, setAlertModal] = useState(false);
  const setUserData = useSetRecoilState(userDataType);

  const { response: checkResponse, error: checkError } = useApi({
    method: "post",
    url: btnClick ? "login/changePW/conform" : undefined,
    data: {
      email,
      password: CryptoJS.enc.Hex.stringify(CryptoJS.SHA1(oldPw)),
    },
  });

  const { response, error } = useApi({
    method: "post",
    url: executeLogout ? `logout` : undefined,
  });

  useEffect(() => {
    if (executeLogout) {
      setIsLoading(true);
    }

    if (response?.status === 200) {
      setIsLoading(false);

      sessionStorage.clear();

      setUserData({
        name: "",
        email: "",
        grade: "",
        sid: "",
      });

      navigate("/");
    } else if ((response?.status ?? 0) > 400) {
      setIsLoading(false);
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      toast.error("로그아웃에 실패했습니다.");
    }
  }, [error]);

  console.log(checkResponse?.data);

  useEffect(() => {
    if (btnClick) {
      if (checkResponse?.data?.code === 200) {
        closeEvent();
        confirmEvent();
      } else if (checkResponse?.data?.code === 403) {
        setAlertModal(true);
      } else {
        // setIsWrong(true);
        setErrMsg(
          loginErrMsgString(
            checkResponse?.data?.code,
            checkResponse?.data?.count
          )
        );
      }
    }
  }, [btnClick, checkResponse, closeEvent, confirmEvent]);

  useEffect(() => {
    if (checkError) {
      setIsWrong(true);
      setErrMsg(checkError?.message ?? "");
    } else {
      setIsWrong(false);
      setErrMsg("");
    }
  }, [checkError]);

  return (
    <DefaultModalLayout
      isMediumModal={true}
      modalTitle={
        pathname === "/login" ? "임시 비밀번호 입력" : "비밀번호 입력"
      }
      closeEvent={() => closeEvent()}
      confirmEvent={() => {
        setBtnClick(true);
      }}
      leftBottomBtn={<></>}
      confirmDisabled={oldPw === "" || isWrong}
      cancelBtn={
        <ConfirmBtn
          btnText="취소"
          btnColor="white"
          btnClickEvent={() => closeEvent()}
        />
      }
    >
      <LoginInputModalContainer>
        {/* 기존 비밀번호 */}
        <LoginInput
          label={pathname === "/login" ? "임시 비밀번호" : "기존 비밀번호"}
          value={oldPw}
          onChangeEvent={(e) => {
            setOldPw(e.target.value);

            if (errMsg !== "") {
              setBtnClick(false);
              setIsWrong(false);
            }
          }}
          isPassword={true}
          hasError={errMsg !== "" ? true : false}
        />

        {errMsg !== "" && <LoginErrorMessage msg={errMsg} />}

        {isLoading && <Loader />}

        {alertModal && (
          <AlertModal
            btnColor="mint"
            title={
              "비밀번호 입력 횟수가 초과되어 이메일로 임시 비밀번호를 발급해 드렸어요.\n임시 비밀번호로 다시 로그인해 주세요."
            }
            customCancelBtn={<></>}
            confirmEvent={() => setExecuteLogout(true)}
          />
        )}
      </LoginInputModalContainer>
    </DefaultModalLayout>
  );
}
